import { createClient } from "@osdk/client";
import { $ontologyRid } from "@unruly-osdk/sdk";
import { createPublicOauthClient } from "@osdk/oauth";
import { checkEnv } from "../helper/helper";

const url = import.meta.env.VITE_FOUNDRY_API_URL;
const clientId = import.meta.env.VITE_FOUNDRY_CLIENT_ID;

checkEnv(url, "VITE_FOUNDRY_API_URL");
checkEnv(clientId, "VITE_FOUNDRY_CLIENT_ID");
export const API_URL = url;

const redirectUrl = location.origin + "/auth-callback";

export const auth = createPublicOauthClient(clientId, url, redirectUrl, {
  useHistory: false, // using history.replaceState() doesn't place well with react-router
  scopes: [
    "api:use-ontologies-read",
    "api:use-ontologies-write",
    "api:use-admin-read",
    "api:use-aip-agents-read",
    "api:use-aip-agents-write",
    "api:use-mediasets-read",
    "api:use-mediasets-write",
  ],
});
/**
 * Initialize the client to interact with the Ontology SDK
 */
export const client = createClient(url, $ontologyRid, auth);
